import { render, staticRenderFns } from "./QurbanData.vue?vue&type=template&id=7a634b84"
import script from "./QurbanData.vue?vue&type=script&lang=js"
export * from "./QurbanData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports